import Checkbox from "@mui/joy/Checkbox";

function CheckBox(props) {
  const { label, ...defaultProps } = props;
  return (
    <div>
      <Checkbox label={label} {...defaultProps} />
    </div>
  );
}

export default CheckBox;
